module.exports = __webpack_public_path__ + "static/img/7002.c0fa49dd.png";